module.exports = __webpack_public_path__ + "img/Address.f617720d.png";